import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import Bao from "./../../services/bao-service";
import BaoRouter from "./../../services/bao-router";
import * as $ from "jquery";
import * as ko from "knockout";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import GenericListTab from "./../../factories/generic-list-tab";
class ConfigurationItemTabBaseDataUniversalField extends GenericListSearchTab {
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.SaveAllowed = parent.SaveAllowed;
        this.Models.subscribe(() => {
            this.Selection([]);
        });
    }
    SaveAllowed: KnockoutObservable<boolean>;
    PageSize = ko.observable(0);
    SearchType() {
        return "Universalfield";
    }
    CustomFilter(): Models.HashObject[] {
        return null;
    }


    link(index: number, model) {
        var linkHash = 'universalField/' + model.UniversalFieldId;
        BaoRouter.setHash(linkHash);
    }

    ToggleToolbarButtons() {
        super.ToggleToolbarButtons();
        ko.utils.arrayForEach(this.ToolbarButtons(), (button: any) => {
            var key = ko.unwrap(button.ActionKey);
            if (key === "ConfigurationItemTabBaseDataUniversalFieldMoveUp"
                || key === "ConfigurationItemTabBaseDataUniversalFieldMoveDown") {
                button.Enabled(this.Selection() != null && this.Selection().length > 0);
            }
        });
    }
    CustomToolbarClick = (action: Interfaces.Bao.BaoMenuItem) => {
        var key = ko.unwrap(action.ActionKey);
        if (key === "ConfigurationItemTabBaseDataUniversalFieldMoveUp") {
            this.moveUniversalField("MoveUp");
        }
        else if (key === "ConfigurationItemTabBaseDataUniversalFieldMoveDown") {
            this.moveUniversalField("MoveDown");
        }
    };
    ItemCompleteCheck(): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }
    private moveUniversalField = (action: string) => {
        this.TabPage.IsLoading(true);
        var selection = this.Selection();
        var guidList = [];
        ko.utils.arrayForEach(selection, function (item) {
            guidList.push(ko.unwrap(item.UniversalFieldConfigurationItemTabId));
        });
        Bao.post("ConfigurationItemTabBaseDataUniversalField/" + action + "ConfigurationItemUniversalField", JSON.stringify({
            sessionTabId: this.SessionTabId,
            id: guidList
        })).done(result => {
            this.Get();
        });
    };
}
export default ConfigurationItemTabBaseDataUniversalField;